<template>
  <div v-if="open" class="plan-required" role="dialog" aria-modal="true" aria-labelledby="plan-required-title" @click.self="close">
    <div class="plan-required__card" data-test="plan-required-modal">
      <div class="plan-required__icon"><span class="material-icons-outlined">lock</span></div>
      <h3 id="plan-required-title" class="plan-required__title">Run this on your own pages</h3>
      <p class="plan-required__sub">
        The example project is read-only. Pick a plan to create projects and run reports.
        Basic starts at {{ basicPrice }}/month with {{ basicCredits }}. Full refund within 7 days.
      </p>
      <button type="button" class="pop-auth__btn pop-auth__btn--primary plan-required__btn" data-test="plan-required-see-plans" @click="seePlans">See plans</button>
      <button type="button" class="pop-auth__link plan-required__keep" @click="close">Keep exploring the demo</button>
    </div>
  </div>
</template>

<script>
import { formatPrice, planById } from './plans'
import { segmentTrack } from '@/utils'

// Lock modal of no-plan accounts: opened by requirePlan(), the router guard or any PLAN_REQUIRED
// API payload (store.planRequiredModal). Mounted once in App.vue.
export default {
  name: 'PlanRequiredModal',
  computed: {
    modal() {
      return this.$store.state.planRequiredModal || {}
    },
    open() {
      return Boolean(this.modal.open)
    },
    basicPrice() {
      const basic = planById('basic')
      return formatPrice(basic && basic.prices ? basic.prices.month : 40)
    },
    basicCredits() {
      const basic = planById('basic')
      return (basic && basic.credits ? basic.credits : '20 credits / month').replace(' / month', '')
    },
  },
  watch: {
    open(value) {
      if (value) segmentTrack('plan_required_modal_shown', { reason: this.modal.reason || '' })
    },
  },
  methods: {
    close() {
      this.$store.commit('hidePlanRequiredModal')
    },
    seePlans() {
      this.close()
      if (this.$route.path !== '/plans') this.$router.push('/plans')
    },
  },
}
</script>

<style scoped lang="scss">
@import './auth-tokens.scss';

.plan-required {
  position: fixed; inset: 0; z-index: 120;
  background: rgba(1, 71, 81, 0.45); backdrop-filter: blur(4px);
  display: flex; align-items: center; justify-content: center; padding: 20px;

  &__card {
    width: 440px; max-width: 100%; max-height: calc(100vh - 40px); overflow-y: auto;
    background: #fff; color: $pop-teal; border-radius: 18px; padding: 30px; text-align: center;
    box-shadow: 0 24px 60px -24px rgba(1, 71, 81, 0.35);
  }
  &__icon {
    width: 56px; height: 56px; border-radius: 16px; background: #ffeddd; color: $pop-accent;
    display: flex; align-items: center; justify-content: center; margin: 0 auto 16px;
    .material-icons-outlined { font-size: 28px; }
  }
  &__title { font-family: 'Mulish', sans-serif; font-weight: 800; font-size: 22px; letter-spacing: -0.02em; margin: 0 0 8px; color: $pop-teal; }
  &__sub { font-size: 14.5px; line-height: 1.55; color: $pop-ink-muted; margin: 0 0 22px; }
  &__btn { margin-top: 0; }
  &__keep { display: inline-block; margin-top: 14px; font-size: 13px; }
}
</style>
